// extracted by mini-css-extract-plugin
module.exports = {"header-footer":"generic-error_header-footer__ECdGz"};